module.exports = __webpack_public_path__ + "static/media/service.436cdede.png";